var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReeveHeaderLineBottomLeft = function SvgReeveHeaderLineBottomLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319,
    height: 736,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000B31",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M318.002 534.82c0 11.421-8.234 20.68-18.391 20.68H91.582c-10.99 0-19.902 8.255-19.902 18.436v142.621c0 10.185-9.26 18.443-20.682 18.443H-7.417M318 534.82V450c0-10.181-8.911-18.435-19.902-18.435H224c-11.421 0-20.681-8.258-20.681-18.443V20.012c0-10.18-8.911-18.435-19.902-18.435H-.681"
  })));
};
export default SvgReeveHeaderLineBottomLeft;